// this file is @generated

// biome-ignore-all lint/suspicious/noEmptyInterface: backwards compat

export interface AdobeSignConfigOut {}

export const AdobeSignConfigOutSerializer = {
  _fromJsonObject(_object: any): AdobeSignConfigOut {
    return {};
  },

  _toJsonObject(_self: AdobeSignConfigOut): any {
    return {};
  },
};
